import { createReducer, on } from '@ngrx/store';

import { Network } from "../../models/network.interface";
import { NetworkActions } from '../actions/network.actions';


export const initialState: Network = {
  loading: false,
  petitions: [ ]
};

export const networkReducer = createReducer(
  initialState,
  on(NetworkActions.load, _state => ({
    petitions: [ ..._state.petitions ],
    loading: true
  })),
  on(NetworkActions.success, (_state, { petition }) => ({
    petitions: [ ..._state.petitions, petition ],
    loading: false
  })),
  on(NetworkActions.error, (_state, { petition }) => ({
    petitions: [ ..._state.petitions, petition ],
    loading: false
  })),
);
